// extracted by mini-css-extract-plugin
export default {"loaderBackdrop":"CustomLoader_loaderBackdrop__Y0SBw","loader":"CustomLoader_loader__h6Iu3","loaderSpin":"CustomLoader_loaderSpin__VT+Xu","spin":"CustomLoader_spin__rf+Wd"};